export default __webpack_public_path__ + "static/8_37-36ece6b1872331fc8311f01f407dc9ac.png";